var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"\n    accord-color-container\n    d-flex\n    flex-wrap\n    pl-5\n  "},_vm._l((_vm.sortColorsItemsByPrice),function(item,index){return _c('accord-colors-item',{key:index,attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }